// extracted by mini-css-extract-plugin
export var divider = "_ma-0";
export var labelWrapper = "_ma-2";
export var lineSvg = "_ma-1";